import React from 'react';
import {
    SwitchContainer,
    Switch,
    SwitchLabel,
    Handle,
    A11yText,
    SettingsLabel,
    Checkbox,
} from './SwitchInput.styles';

export enum InputSize {
    Default = 'default',
    Small = 'small',
}

export enum SwitchInputTheme {
    Default = 'default',
    Secondary = 'secondary',
}

type Props = {
    checked: boolean;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    inputName?: string;
    dataRt?: string;
    labelText?: string;
    a11yText?: string;
    bounceLeft?: boolean;
    bounceRight?: boolean;
    className?: string;
    size?: InputSize;
    theme?: SwitchInputTheme;
};

const SwitchInput = ({
    checked,
    onChange,
    inputName,
    dataRt,
    labelText,
    a11yText,
    bounceLeft = false,
    bounceRight = false,
    className = undefined,
    size = InputSize.Default,
    theme = SwitchInputTheme.Default,
}: Props) => (
    <SwitchContainer className={className} size={size}>
        <Switch theme={theme}>
            <Checkbox
                type="checkbox"
                name={inputName}
                id={inputName}
                checked={checked}
                onChange={onChange}
                aria-checked={checked}
                data-testid="switch-input"
            />
            <SwitchLabel checked={checked} htmlFor={inputName} data-rt={dataRt} theme={theme}>
                <Handle checked={checked} bounceLeft={bounceLeft} bounceRight={bounceRight} />
                <A11yText>{a11yText}</A11yText>
            </SwitchLabel>
        </Switch>
        <SettingsLabel as="p">{labelText}</SettingsLabel>
    </SwitchContainer>
);

export default SwitchInput;
